export class Department {
    constructor(
      id,
      name,
      erpRRHHId,
      deletedAt,
    ) {
        this.id = id;
        this.name = name;
        this.erpRRHHId = erpRRHHId;
        this.deletedAt = deletedAt;
    }
    static createFromResponseData(data) {
      return new Department(
        data.id,
        data.name,
        data.erpRRHHId,
        data.deletedAt,
      );
    }
  };